export const RESTART_ON_REMOUNT = '@@saga-injector/restart-on-remount';
export const DAEMON = '@@saga-injector/daemon';
export const ONCE_TILL_UNMOUNT = '@@saga-injector/once-till-unmount';

export const MAX_HOURS_CHECK_IN = 1;
export const MIN_HOURS_CHECK_IN = -0.15;

// Global variable to indicate if we are in prod.
export const isProduction = process.env.REACT_APP_ENVIRONMENT === 'production';
